export default "__VITE_ASSET__w7IKi_D8__"